import { EmployeeStatus } from "../types/processTypes";

const FORWARD_PIPELINE: EmployeeStatus[] = [
  EmployeeStatus.contracted,
  EmployeeStatus.visa_issued,
  EmployeeStatus.labour_issued,
  EmployeeStatus.ticketing,
  EmployeeStatus.flight_booked,
  EmployeeStatus.departed,
];

/**
 * VisaEntry is the agreement/contract form. It must advance selected/new into
 * contracted, but must never demote an employee who is already past contracted
 * (e.g. after embassy stamp → visa_issued).
 */
export function resolveVisaEntrySubmitStatus(
  current?: EmployeeStatus,
): EmployeeStatus {
  if (!current) return EmployeeStatus.contracted;
  const rank = FORWARD_PIPELINE.indexOf(current);
  if (rank > 0) return current;
  return EmployeeStatus.contracted;
}
